<div class="step-existing-orders">
  <div class="step-header">
    <div>
      <h3>Pedidos Existentes</h3>
      <p class="step-subtitle">
        Pedidos abertos do marina (sem fatura) que podem ser anexados ao
        processo de faturamento de
        <strong>{{ process.referenceMonth }}/{{ process.referenceYear }}</strong>.
      </p>
    </div>
    <button pButton type="button" class="easymarine secondary"
      icon="pi pi-refresh" label="Recarregar elegíveis"
      [disabled]="loading" (click)="reload()"></button>
  </div>

  <div class="summary-cards">
    <div class="summary-card" [class.empty]="countAvailable === 0">
      <div class="summary-card-header">
        <i class="pi pi-file-edit"></i>
        <span class="summary-card-title">Pedidos abertos</span>
      </div>
      <div class="summary-card-body">
        <div class="summary-row">
          <span class="summary-row-label">Disponíveis</span>
          <span class="summary-row-value">{{ countAvailable }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-row-label">Total disponível</span>
          <span class="summary-row-value money">
            {{ totalAvailable | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
          </span>
        </div>
        <div class="summary-row selected">
          <span class="summary-row-label">Selecionados</span>
          <span class="summary-row-value">{{ countSelected }}</span>
        </div>
        <div class="summary-row selected">
          <span class="summary-row-label">Total selecionado</span>
          <span class="summary-row-value money">
            {{ totalSelected | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
          </span>
        </div>
      </div>
      <div class="summary-card-actions">
        <button pButton type="button" class="easymarine secondary"
          icon="pi pi-sliders-h" label="Personalizar"
          [disabled]="countAvailable === 0"
          (click)="openPersonalize()"></button>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && items.length === 0" class="empty-state">
    <i class="pi pi-inbox"></i>
    <h4>Nenhum pedido aberto encontrado</h4>
    <p>Não há marina_orders sem fatura para anexar a esse processo.</p>
  </div>

  <div class="step-actions">
    <button pButton type="button" class="easymarine secondary"
      icon="pi pi-arrow-left" label="Anterior"
      [disabled]="loading" (click)="back.emit()"></button>
    <button pButton type="button" class="easymarine primary"
      icon="pi pi-arrow-right" iconPos="right" label="Próximo"
      [disabled]="loading" (click)="next.emit()"></button>
  </div>

  <p-dialog
    [(visible)]="personalizeOpen"
    [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
    [style]="{ width: '1200px', maxWidth: '95vw' }"
    header="Personalizar — Pedidos Existentes"
    (onHide)="closePersonalize()">

    <div class="personalize-content">
      <div class="personalize-toolbar">
        <button pButton type="button" class="easymarine secondary"
          icon="pi pi-check-square" label="Marcar todos"
          (click)="toggleAll(true)"></button>
        <button pButton type="button" class="easymarine secondary"
          icon="pi pi-stop" label="Desmarcar todos"
          (click)="toggleAll(false)"></button>
        <span class="p-input-icon-left personalize-search">
          <i class="pi pi-search"></i>
          <input pInputText type="text" placeholder="Buscar por embarcação, cliente ou pedido"
            (input)="personalizeTable.filterGlobal($any($event.target).value, 'contains')" />
        </span>
      </div>

      <div class="personalize-filters">
        <label class="filter-checkbox">
          <p-checkbox [binary]="true" [(ngModel)]="showOnlyEligible"></p-checkbox>
          <span>Exibir somente elegíveis</span>
        </label>
        <p-multiSelect
          [options]="originOptions"
          [(ngModel)]="selectedOriginFilter"
          optionLabel="label" optionValue="value"
          placeholder="Filtrar por origem"
          selectedItemsLabel="{0} origens selecionadas"
          [maxSelectedLabels]="3"
          styleClass="filter-origin"
          appendTo="body">
          <ng-template let-option pTemplate="item">
            <span>{{ option.label | translate }}</span>
          </ng-template>
          <ng-template let-value pTemplate="selectedItems">
            <ng-container *ngIf="!value || value.length === 0">Filtrar por origem</ng-container>
            <ng-container *ngIf="value && value.length > 0 && value.length <= 3">
              <span *ngFor="let v of value; let last = last">
                {{ v | translate }}<ng-container *ngIf="!last">, </ng-container>
              </span>
            </ng-container>
            <ng-container *ngIf="value && value.length > 3">
              {{ value.length }} origens selecionadas
            </ng-container>
          </ng-template>
        </p-multiSelect>
      </div>

      <p-table #personalizeTable [value]="personalizeItems"
        [paginator]="personalizeItems.length > 100"
        [rows]="100" [rowsPerPageOptions]="[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]"
        [globalFilterFields]="['displayName', 'boatName', 'productName',
          'customers.0.customerName', 'customers.1.customerName']"
        styleClass="p-datatable-sm personalize-table">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 60px">Sel.</th>
            <th style="width: 110px">Nº pedido</th>
            <th>Embarcação</th>
            <th>Cliente</th>
            <th style="width: 130px">Origem</th>
            <th style="width: 150px; text-align: right">Valor</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [class.row-skipped]="isLocked(item)"
              [class.row-selected]="item.selected && !isLocked(item)">
            <td>
              <p-checkbox [binary]="true" [ngModel]="item.selected"
                (onChange)="toggle(item)" [disabled]="isLocked(item)"></p-checkbox>
            </td>
            <td>{{ orderNumberOf(item) || '—' }}</td>
            <td>{{ item.boatName || '—' }}</td>
            <td>
              <div class="cell-customer" [pTooltip]="customerTooltip(item)" tooltipPosition="top">
                <span class="customer-names">{{ customerSummary(item) || '—' }}</span>
              </div>
            </td>
            <td>{{ (item.productName | translate) || '—' }}</td>
            <td style="text-align: right">
              {{ item.computedTotal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" style="text-align: center; padding: 24px">
              Nenhum pedido nesta lista.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <ng-template pTemplate="footer">
      <button pButton type="button" class="easymarine primary"
        icon="pi pi-check" label="Concluir" (click)="closePersonalize()"></button>
    </ng-template>
  </p-dialog>
</div>
